import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WholesaleSummary } from '@galaxy/inventory-ui';
import {
  FuturePaymentsDisplayComponent,
  FuturePaymentDisplayItemsWithCurrency,
} from '../future-payments-display/future-payments-display.component';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { convertFuturePaymentItemsMapIntoFuturePaymentDisplayItemArray } from '../../shared/utils';
import { MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { TranslateModule } from '@ngx-translate/core';
import { BillingUiModule } from '@vendasta/billing-ui';
import { MatTooltipModule } from '@angular/material/tooltip';
import { GalaxyTooltipModule } from '@vendasta/galaxy/tooltip';
@Component({
  selector: 'orders-wholesale-summary',
  imports: [
    MatExpansionPanelTitle,
    TranslateModule,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    BillingUiModule,
    CommonModule,
    MatTooltipModule,
    GalaxyTooltipModule,
    FuturePaymentsDisplayComponent,
  ],
  templateUrl: './wholesale-summary.component.html',
  styleUrl: './wholesale-summary.component.scss',
})
export class WholesaleSummaryComponent {
  @Input() set wholesaleSummary(wholesaleSummary: WholesaleSummary) {
    this.wholesaleSummary$$.next(wholesaleSummary);
  }

  wholesaleSummary$$: BehaviorSubject<WholesaleSummary> = new BehaviorSubject<WholesaleSummary>(undefined);
  protected futurePaymentDisplayItems$: Observable<FuturePaymentDisplayItemsWithCurrency>;
  protected wholesaleSummary$: Observable<WholesaleSummary>;

  constructor() {
    this.futurePaymentDisplayItems$ = this.wholesaleSummary$$.pipe(
      distinctUntilChanged(),
      map((wholesaleSummary) =>
        convertFuturePaymentItemsMapIntoFuturePaymentDisplayItemArray(
          wholesaleSummary?.futurePayments,
          wholesaleSummary?.currencyCode,
        ),
      ),
    );
    this.wholesaleSummary$ = this.wholesaleSummary$$.pipe(distinctUntilChanged());
  }
}
